module.exports = __webpack_public_path__ + "img/154-595c70.png";